/* <template>
  <div class="content" id="d1">
    <div class="main" v-loading="loading">
      <div class="top-operation clearfix">
        <!-- <el-button type="primary" @click="addGroupVisible = true">创建集体备课</el-button> -->
        <el-button type="primary" @click="addGroup();flag = false" v-if="this.role == 'admin' && teacher_info == 1">
          创建集体备课</el-button>
        <span :class="{'active':created_by_me == 1}" @click="created_by_me = 1; getActivityInfoList()"
          style="cursor:pointer">我创建的备课</span>
        <span :class="{'active':created_by_me == 0}" @click="created_by_me = 0; getActivityInfoList()"
          style="cursor:pointer">全部</span>
      </div>
      <div v-if="isData" class="none">暂无集体备课</div>
      <!-- <div v-if="false" class="none">暂无集体备课</div> -->
      <div class="group-list clearfix" v-for="(item,index) in tableData" :key="index">
        <div class="group-info">
          <p class="p1">
            <span class="title" style="cursor:pointer" @click="goInfo(item)">{{item.title}}</span>
            <!-- 此处如果是已结束，使用class="status-end"-->
            <span :class="item.statusClass">{{item.statusName}}</span>
            <span v-if="item.is_disable" style="color:red;margin: 20px">(被屏蔽)</span>
          </p>
          <p class="p2">
            <span class="span-1">主持人：{{item.username}}</span>
            <span class="span-1">参与人数：{{item.member_list.length}}</span>
            <span class="span-1">权限：{{item.auth_name}}</span>
          </p>
          <p class="p2">
            <span class="span-1">创建时间：{{item.begin_time.substr(0,16)}} - {{item.end_time.substr(0,16)}}</span>
            <span v-if=" role == 'admin' && item.userid == user_id && teacher_info == 1">
              <el-button @click="delGroup(item)">删除</el-button>
              <el-button v-if="item.is_disable" :disabled="true">编辑</el-button>
              <el-button v-else :style="selfstyle" @click="editGroup(item),flag = true">编辑</el-button>
            </span>
          </p>
        </div>
      </div>
      <!-- 分页 -->
      <el-pagination background layout="prev, pager, next" @current-change="PageChange" :current-page="this.page"
        :page-size="this.pageSize" :total="this.totle" :hide-on-single-page="true"></el-pagination>
    </div>

    <!-- 创建集体备课-->
    <el-dialog title="创建集体备课" :visible.sync="addGroupVisible" width="600px" :close-on-click-modal="false"
      :close-on-press-escape="false" @close="closeDialog">
      <p class="p-1">
        <span class="title">活动标题：</span>
        <span style="color:red">*</span>
      </p>
      <p class="p-1">
        <el-input v-model="actTitle" maxlength="20" placeholder="请输入标题 , 20字以内" show-word-limit style="width:400px">
        </el-input>
      </p>
      <p class="p-1">
        <span class="title">起止时间：</span>
        <span style="color:red">*</span>
      </p>
      <p class="p-1 p-time">
        <el-button type="info" plain>现在</el-button>
        <el-date-picker v-model="endTime" type="datetime" format="yyyy-MM-dd HH:mm:ss"
          :picker-options="expireTimeOption" placeholder="选择日期时间"></el-date-picker>
      </p>
      <p class="p-1">
        <span class="title">活动简介</span>
      </p>
      <p class="p-1">
        <el-input type="textarea" maxlength="200" :autosize="{ minRows: 4, maxRows: 8}" placeholder="输入活动简介 , 200字以内"
          v-model="actIntro"></el-input>
      </p>
      <p class="p-1">
        <span class="title">备课草案</span>
      </p>
      <p class="p-1">
        <uploader ref="uploader" class="uploader-example" :options="options" :autoStart="false"
          :file-status-text="statusText" @file-success="handleSuccess" @file-added="filesAdded"
          @file-progress="fileProgress" @files-submitted="filesSubmitted" @file-error="onFileError"
          @file-removed="beforeRemove">
          <uploader-unsupport></uploader-unsupport>
          <uploader-drop>
            <uploader-btn :single="false" :attrs="attrs1">点击上传</uploader-btn>
          </uploader-drop>
          <uploader-list></uploader-list>
        </uploader>
        <span slot="tip" class="el-upload__tip">仅支持格式word/excel/ppt/txt/mp4，单个文件不超过200M</span>
      </p>

      <p class="p-1">
        <span class="title">
          讨论人员
          <span style="color:red">*</span>
        </span>
      </p>
      <p class="p-1">
        <el-button plain @click="addUserVisible=true,getProvince(),dialog_page=1;">添加人员</el-button>
        <span slot="tip" class="el-upload__tip">讨论人员请登录视频会议软件参与讨论，最多支持15个屏幕进行视频会议</span>
      </p>
      <p class="p-1">
        <el-tag v-for="tag in tags" :key="tag.userid" closable @close="handleClose(tag)">{{tag.username}}</el-tag>
      </p>
      <p class="p-1">
        <span class="title">权限</span>
      </p>
      <p class="p-1">
        <el-select v-model="actAuth" placeholder="请选择">
          <el-option v-for="item in auth_options" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </p>

      <p class="p-1">
        <el-button type="primary" @click="createActivity" :disabled="isSubmit">创建</el-button>
        <el-button @click="addGroupVisible = false; closeDialog()">取 消</el-button>
      </p>
    </el-dialog>
    <!-- 创建集体备课 -->

    <!-- 编辑集体备课-->
    <el-dialog title="编辑集体备课" :visible.sync="editGroupVisible" width="600px" :close-on-click-modal="false"
      :close-on-press-escape="false" @close="cancelEdit()">
      <p class="p-1">
        <span class="title">活动标题</span>
      </p>
      <p class="p-1">
        <el-input v-model="editActTitle" @keydown.native="changeEdit()" maxlength="20" placeholder="标题 , 20字以内"
          show-word-limit style="width:415px;"></el-input>
      </p>
      <p class="p-1">
        <span class="title">起止时间</span>
      </p>
      <p class="p-1 p-time">
        <el-button type="info" plain style="width:200px;">{{this.startTime}}</el-button>
        <el-date-picker v-model="editEndTime" @change="changeEdit()" type="datetime" format="yyyy-MM-dd HH:mm:ss"
          placeholder="选择日期时间" :picker-options="expireTimeOption" style="width:200px;"></el-date-picker>
      </p>
      <p class="p-1">
        <span class="title">活动简介</span>
      </p>
      <p class="p-1">
        <el-input type="textarea" @keydown.native="changeEdit()" maxlength="200" :autosize="{ minRows: 4, maxRows: 8}"
          placeholder="输入活动简介 , 200字以内" v-model="editActIntro"></el-input>
      </p>
      <p class="p-1">
        <span class="title">备课草案</span>
      </p>
      <p class="p-1">
        <uploader ref="uploader" class="uploader-example" :options="options" :autoStart="false"
          :file-status-text="statusText" @file-success="editHandleSuccess" @file-added="filesAdded"
          @files-submitted="filesSubmitted" @file-progress="fileProgress" @file-error="onFileError"
          @file-removed="editBeforeRemove">
          <uploader-unsupport></uploader-unsupport>
          <uploader-drop>
            <uploader-btn :single="true" :attrs="attrs1">点击上传</uploader-btn>
          </uploader-drop>
          <uploader-list v-show="panelShow"></uploader-list>
        </uploader>
      <ul class="el-upload-list el-upload-list--text" v-show="show_filename">
        <li tabindex="0" class="el-upload-list__item is-success" v-for="(item, i) in res_list1" :key="i">
          <a class="el-upload-list__item-name">
            <i class="el-icon-document"></i>
            {{item.name}}
          </a>
        </li>
      </ul>
      </p>

      <p class="p-1">
        <span class="title">
          讨论人员
          <span style="color:red">*</span>
        </span>
      </p>
      <p class="p-1">
        <el-button plain @click="addUserVisible=true,getProvince(),dialog_page=1;">添加人员</el-button>
        <span slot="tip" class="el-upload__tip">讨论人员请登录视频会议软件参与讨论，最多支持15个屏幕进行视频会议</span>
      </p>
      <p class="p-1">
        <el-tag v-for="tag in tags" :key="tag.userid" closable @close="handleClose(tag)">{{tag.username}}</el-tag>
      </p>
      <p class="p-1">
        <span class="title">权限</span>
      </p>
      <p class="p-1">
        <el-select @change="changeEdit()" v-model="editActAuth" placeholder="请选择">
          <el-option v-for="item in auth_options" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </p>

      <p class="p-1">
        <el-button type="primary" :disabled="disabled2" @click="editActivity">保存</el-button>
        <el-button @click="editGroupVisible = false; cancelEdit()">取 消</el-button>
      </p>
    </el-dialog>
    <!-- 编辑集体备课 -->

    <!-- 添加人员-->
    <el-dialog title="添加成员" :visible.sync="addUserVisible" width="550px" :close-on-click-modal="false"
      :close-on-press-escape="false">
      <p class="user-type">
        <el-button round :type="buttonStyle1" @click="selectUserFun(1)">教师</el-button>
        <el-button :type="buttonStyle2" round @click="selectUserFun(2)">教研员</el-button>
      </p>
      <!-- 教师可以按id或姓名搜索 -->

      <p class="select-other">
        <el-select v-model="provinceValue" placeholder="不限" @change="selProvince()">
          <el-option v-for="item in provinceList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
        <el-select v-model="cityValue" placeholder="不限" @change="selCity()">
          <el-option v-for="item in cityList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
        <el-select v-model="districtValue" placeholder="不限" @change="selCounty()">
          <el-option v-for="item in countyList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
        <el-input placeholder="搜索机构" v-model="org_keyword" @keyup.enter.native="selTeacherFormOrg">
          <el-button slot="append" icon="el-icon-search" @click="selTeacherFormOrg"></el-button>
        </el-input>
      </p>
      <p class="select-user">
        <el-input @keyup.enter.native="getTeacherList" placeholder="账号/姓名" prefix-icon="el-icon-search"
          v-model="dialog_select_word"></el-input>
        <el-button type="primary" @click="getTeacherList">搜索</el-button>
      </p>
      <table class="usersInfo">
        <div class="none-none" v-if="this.teacherList.length == 0">{{tsXx}}</div>
        <div v-else class="table-div">
          <tr class="user-list" v-for="(item, index) in teacherList" :key="index">
            <td width="200">
              <img class="user-face" :src="item.face_logo" :onerror="errorImg" alt />
              <span class="schoolName username" :title="item.username">{{item.username}}</span>
            </td>
            <td>
              <span>{{item.userid}}</span>
            </td>
            <td width="150">
              <span class="schoolName school_name" :title="item.school_name">{{item.school_name}}</span>
            </td>
            <td>
              <span style="color: #b5b9bd;"
                v-if="isInArray(add_member_list, item.userid) || zone_userid == item.userid">已添加</span>
              <span style="color: rgb(64,158,255);cursor:pointer;" @click="addMember(item)" v-else>添加</span>
            </td>
          </tr>
          <tr>
            <td colspan="4">
              <!-- <el-pagination small layout="prev, pager, next" :total="teacher_sum"></el-pagination> -->
              <div v-if="this.teacher_sum <= this.dialog_page_size ? false : true" class="btnGroup">
                <div class="pagination">
                  <el-pagination background @current-change="handleCurrentDialogChange" :current-page="this.dialog_page"
                    :page-size="this.dialog_page_size" layout="prev, pager, next" :total="this.teacher_sum">
                  </el-pagination>
                </div>
              </div>
            </td>
          </tr>
        </div>
      </table>
    </el-dialog>
    <!-- 添加人员-->

    <!-- 删除备课-->
    <el-dialog title="删除备课" :visible.sync="delGroupVisible" width="300px" :center="true"
      style="margin-top: 30vh !important;">
      <span>确认删除该活动吗？</span>
      <br />
      <br />
      <span class="del-span">活动内的资源也将被删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="delData()">确 定</el-button>
        <el-button @click="delGroupVisible = false">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 删除备课-->
  </div>
</template>

<script>
import globalApi from "@/common/globalApi.js";
import { log } from "util";
import SparkMD5 from "spark-md5";
export default {
  name: "weike",
  data() {
    return {
      selfstyle: {
        //默认按钮
        color: "#FFFFFF",
        backgroundColor: "#66B1FF",
        borderColor: "#66B1FF",
        height: "32px",
        width: "80px",
      },
      errorImg:
        'this.src="' + require("../../assets/img/menu_mine_on@3x.png") + '"', // 图片损坏默认图
      show_filename: true, // 编辑视频-是否显示文件名
      editActAuth: "",
      edit_file_resource_list: [],
      editActIntro: "",
      editActTitle: "",
      editEndTime: "",
      editGroupVisible: false,
      addGroupVisible: false, // 创建专题工作显示
      delGroupVisible: false, // 解散专题工作显示
      addUserVisible: false, // 添加人员显示
      actIntro: "", // 活动简介
      dialogImageUrl: "",
      dialogVisible: false,
      thisSelectUserType: 1, // 当前选择的人员 1=教师2=教研员
      tsXx: "暂无数据",
      endTime: "", // 结束时间
      actTitle: "", // 备课标题
      buttonStyle1: "primary",
      buttonStyle2: "",
      provinceValue: "", // 省
      cityValue: "", // 市
      districtValue: "", // 区
      isData: false, // 缺省页是否显示
      disabled2: true, // 编辑确定按钮
      auth_options: [
        {
          value: 1,
          label: "仅参与人员",
        },
        {
          value: 2,
          label: "公开",
        },
      ],
      actAuth: 1, // 权限的值
      tags: [],
      // 省市区
      province: [],
      city: [],
      district: [],
      zone_userid: 0, // 当前空间用户的id
      cur_page: 1, // 当前页
      tableData: [], // 备课列表数据
      page: 1,
      pageSize: 12,
      totle: 0,
      cur_id: 0, //当前操作id
      isLogin: false,
      username: false,
      user_id: 0,
      provinceList: [],
      cityList: [],
      city_id: 0,
      countyList: [],
      org_keyword: "",
      role: "visitor",
      selIdentity: 1,
      teacherList: [],
      dialog_page: 1,
      dialog_page_size: 10,
      teacher_sum: 0,
      add_member_list: [],
      cur_city_id: "", //当前区域id
      dialog_select_word: "",
      fileList: [],
      file_resource_id: "",
      file_resource_list: [],
      res_list1: [],
      startTime: "",
      cur_id: "", //当前编辑的id
      res_list2: [], //不包含备课草案的附件集合
      created_by_me: 0,
      login_userid: 1,
      expireTimeOption: {
        disabledDate(date) {
          //disabledDate 文档上：设置禁用状态，参数为当前日期，要求返回 Boolean
          return date.getTime() < Date.now();
        },
      },
      level: 0,
      last_req_keyword: "", //上次请求的关键字，用于观测关键字刷选变化，如果有变化，当前页为1
      schoolid: 0,
      teacher_info: 0,
      uploadUrl: "", // 文件上传地址
      uploadData: "", // 文件上传参数

      user_county: "", //空间用户所属区县
      user_city: "", //空间用户所属城市
      user_province: "", //空间用户所属省市
      user_belong: "", //用户所属城市
      // 分片参数
      // 文档
      FileLimit1: {
        FileMaxSize: 200, // 允许上传的大小 单位(M)
        FileFormat: ["doc", "docx", "xls", "xlsx", "ppt", "pptx", "txt", "mp4"], // 允许上传的格式
        FileUnit: "M", // 单位
      },
      options: {},
      statusText: {
        success: "上传成功！",
        error: "出错了！",
        uploading: "上传中...",
        paused: "等待中...",
        waiting: "等待中...",
      },
      panelShow: true, // 展示上传panel
      attrs1: {
        accept: ".doc, .docx, .xls, .xlsx, .ppt, .pptx, .txt, .mp4",
      },
      isSubmit: false,
      flag: false,
      loading: false,
      websiteSessionInfo: globalApi.gWebsiteSessionInfo,
    };
  },

  components: {},
  computed: {
    globalVaranthasInited() {
      return globalApi.gWebsiteSessionInfo.hasInited;
    },
  },
  watch: {
    globalVaranthasInited: function () {
      this.init();
    },
  },
  created() {},

  methods: {
    init() {
      this.zone_userid = this.$route.query.userid;
      this.getLoginInfo();
      this.getInfo();
    },
    //获取教师空间信息
    async getInfo() {
      const data = {
        s: "WebTeacherSpace.TeacherInfo.GetInfo",
        teacher_id: this.zone_userid,
      };
      let res = await globalApi.post(data);
      this.user_belong = res.data.data.cityid;
      this.getUserBelong();
      this.schoolid = res.data.data.schoolid;
      this.teacher_info = res.data.data.status;
      this.getActivityInfoList();
    },

    //获取用户所属地区
    async getUserBelong() {
      const data = {
        s: "WebTeacherSpace.TeacherInfo.getUserBelong",
        user_belong: this.user_belong,
      };
      let res = await globalApi.post(data);
      this.user_city = res.data.data.city;
      this.user_county = res.data.data.county;
      this.user_province = res.data.data.province;
    },
    // 改变编辑状态
    changeEdit() {
      this.disabled2 = false;
    },

    //分页导航
    PageChange(val) {
      this.page = val;
      this.getActivityInfoList(); // 获取资源文章
    },
    //访问详情页面
    async goInfo(item) {
      if (item.is_disable) {
        this.$message.error(
          "本集体备课已被屏蔽，请联系管理员取消屏蔽后方可进入!"
        );
        return;
      }
      if (item.activity_permission == 2) {
        let host = globalApi.GetWebHost("article");
        window.open(
          host + "school_activity_preparation_info?act_id=" + item.id
        );
        return;
      }
      if (
        this.isInArray(item.member_list, this.user_id) &&
        item.activity_permission == 1
      ) {
        let host = globalApi.GetWebHost("article");
        window.open(
          host + "school_activity_preparation_info?act_id=" + item.id
        );
      } else {
        if (this.isLogin) {
          this.$message.error("对不起，你没有该权限！");
        } else {
          let fromurl = encodeURIComponent(location.href);
          location.href = globalApi.GetWebHost("login") + '?fromurl=' + fromurl;
        }
      }
    },

    //清空控件内容
    cancelEdit() {
      for (let i in this.$refs.uploader.files) {
        this.$refs.uploader.files[i].cancel();
      }
    },
    closeDialog() {
      for (let i in this.$refs.uploader.files) {
        this.$refs.uploader.files[i].cancel();
      }
    },

    //编辑集体备课
    async editGroup(item) {
      this.disabled2 = true;
      let id = item.id;
      const data = {
        s: "WebSchoolSpace.LessonPreparation.getActivitySimpleInfo",
        id: id,
      };
      let res = await globalApi.post(data);

      let info = res.data.data.info;

      this.clearMemberSel();
      this.res_list = [];
      this.res_list1 = [];
      this.res_list2 = [];
      this.editGroupVisible = true;
      this.editActAuth = info.activity_permission;
      this.editActIntro = info.describle;
      this.editActTitle = info.title;
      this.cur_id = info.id;
      this.editEndTime = info.end_time;

      this.startTime = info.begin_time;
      this.add_member_list = info.member_list;
      this.tags = info.member_info_list;
      this.cur_resList = info.res_list;
      let tmp_list = info.res_list;
      for (var i = 0; i < tmp_list.length; i++) {
        if (tmp_list[i].type == 1) {
          this.res_list1.push(tmp_list[i]);
        } else {
          this.res_list2.push(tmp_list[i]);
        }
      }
    },
    async editActivity() {
      this.disabled2 = true;
      setTimeout(() => {
        this.disabled2 = false; //点击一次时隔两秒后才能再次点击
      }, 2000);

      let tmp_list = this.res_list1.concat(this.res_list2);
      let res_list = JSON.stringify(tmp_list);

      if (this.add_member_list.length == 0) {
        this.$message.error("成员列表不能为空！");
        return;
      }
      let member_list = JSON.stringify(this.add_member_list);
      let endTime = 0;
      let cur_time = parseInt(new Date().getTime()); //当前时间戳

      if (typeof this.editEndTime == "object") {
        endTime = this.editEndTime.valueOf();
      } else {
        let date = this.editEndTime.replace(/-/g, "/"); //必须把日期'-'转为'/'
        endTime = new Date(date).getTime();
      }
      const data = {
        s: "WebTeacherSpace.LessonPreparation.UpdateActivityInfo",
        operatorid: this.user_id,
        activityid: this.cur_id,
        title: this.editActTitle,
        end_time: endTime,
        describle: this.editActIntro,
        res_list: res_list,
        member_list: member_list,
        permission: this.editActAuth,
      };
      const res = await globalApi.post(data);
      if (res.data.ret == 200 && res.data.data.result == 1) {
        this.editGroupVisible = false;
        this.$message.success("编辑成功！");
        this.getActivityInfoList();
      } else {
        this.$message.error("编辑失败！");
      }
    },
    editBeforeRemove(file, fileList) {
      this.disabled2 = false;
      let id = file.resid;

      let newData = this.res_list1.filter(function (item) {
        return item.resid != id;
      });
      this.res_list1 = newData;
    },
    //获取当前的日期时间
    getCurrentDate() {
      var timeStr = "-";
      var curDate = new Date();
      var curYear = curDate.getFullYear(); //获取完整的年份(4位,1970-????)
      var curMonth = curDate.getMonth() + 1; //获取当前月份(0-11,0代表1月)
      if (curMonth < 10) {
        curMonth = "0" + curMonth;
      }
      var curDay = curDate.getDate(); //获取当前日(1-31)
      if (curDay < 10) {
        curDay = "0" + curDay;
      }
      var curWeekDay = curDate.getDay(); //获取当前星期X(0-6,0代表星期天)
      var curHour = curDate.getHours(); //获取当前小时数(0-23)
      var curMinute = curDate.getMinutes(); // 获取当前分钟数(0-59)
      var curSec = curDate.getSeconds(); //获取当前秒数(0-59)
      var Current =
        curYear +
        timeStr +
        curMonth +
        timeStr +
        curDay +
        " " +
        curHour +
        ":" +
        curMinute +
        ":" +
        curSec;
      return Current;
    },
    editHandleSuccess: function (rootFile, file, response, chunk) {
      var res = JSON.parse(response);
      let tmpFile = {};
      tmpFile.resid = res.Data.Original;
      tmpFile.name = file.name;
      tmpFile.userid = this.user_id;
      tmpFile.time = this.getCurrentDate();
      tmpFile.type = 1;
      if (res.Result) {
        this.disabled2 = false;
        this.res_list1.push(tmpFile);
      } else {
        if (response.ErrCode != 4) {
          this.$message.error(response.Errstr);
        }
      }
      this.disabled2 = false;
    },
    //选人分页
    handleCurrentDialogChange(val) {
      this.dialog_page = val;
      if (this.org_keyword != "") {
        this.selTeacherFormOrg();
      } else {
        this.getTeacherList();
      }
    },
    clearMemberSel() {
      this.org_keyword = "";
      this.districtValue = "";
      this.add_member_list = [];
      this.dialog_select_word = "";
      this.teacherList = [];
      this.cur_city_id = 0;
      this.countyList = [];
      this.tags = [];
      this.cityValue = "";
      this.provinceValue = "";
      this.cityList = [];
      this.districtValue = "";
      this.level = 0;
    },
    //创建集体备课
    async addGroup() {
      const is_login = await globalApi.CheckAndGotoLogin();
      if (!is_login) {
        return;
      }
      this.clearMemberSel();
      this.isSubmit = false;
      this.actTitle = "";
      this.endTime = "";
      this.actIntro = "";
      this.tags = [];
      this.actAuth = 1;
      this.panelShow = false;
      this.addGroupVisible = true;
    },

    //获取省份、直辖市
    async getProvince() {
      let data = {
        s: "WebTeacherSpace.TeacherInfo.GetProvince",
        schoolid: 1,
      };
      let res = await globalApi.post(data);
      if (res.data.ret != 200) {
        return false;
      }
      this.provinceList = res.data.data.citys;
      this.provinceValue = this.user_province;
      this.cityValue = this.user_city;
      this.districtValue = this.user_county;
      this.getCity();
      this.getCounty();
      if (this.districtValue == "") {
        this.level = 3;
        this.cur_city_id = this.cityValue;
      } else {
        this.level = 4;
        this.cur_city_id = this.districtValue;
      }
      this.getTeacherList();
    },

    selProvince() {
      this.countyList = [];
      this.org_keyword = "";
      this.cityValue = "";
      this.districtValue = "";
      this.teacherList = [];
      this.dialog_select_word = "";
      this.cur_city_id = 0;
      this.getCity();
    },
    //选择城市
    selCity() {
      this.cur_city_id = this.cityValue;
      // (this.county = ""), (this.countyList = []);
      this.org_keyword = "";
      this.districtValue = "";
      this.level = 3;
      this.getTeacherList();
      if (this.provinceValue != "") {
        this.getCounty();
      }
    },
    //选择区县
    selCounty() {
      this.cur_city_id = this.districtValue;
      this.org_keyword = "";
      this.city_id = this.county;
      this.level = 4;
      this.getTeacherList();
    },

    //获取城市、区
    async getCity() {
      let data = {
        s: "WebTeacherSpace.TeacherInfo.GetChildCitys",
        parent_cityid: this.provinceValue,
        schoolid: 1,
      };
      let res = await globalApi.post(data);
      if (res.data.ret != 200) {
        return false;
      }
      this.cityList = res.data.data.citys;
    },

    //获取区县
    async getCounty() {
      let data = {
        s: "WebTeacherSpace.TeacherInfo.GetChildCitys",
        parent_cityid: this.cityValue,
        schoolid: 1,
      };
      let res = await globalApi.post(data);
      if (res.data.ret != 200) {
        return false;
      }
      this.countyList = res.data.data.citys;
    },

    //选择教师
    async getTeacherList() {
      this.teacherList = [];
      if (this.thisSelectUserType == 1) {
        if (this.last_req_keyword != this.dialog_select_word) {
          this.dialog_page = 1;
        }

        if (this.cur_city_id == "" || this.level == 0) {
          this.$message.error("请选择城市或区县！");
          return;
        }
        this.last_req_keyword = this.dialog_select_word;
        let data = {
          s: "WebTeacherSpace.LessonPreparation.GetMember",
          zone_userid: this.zone_userid,
          page_size: this.dialog_page_size,
          page: this.dialog_page,
          city_id: this.cur_city_id,
          keyword: this.dialog_select_word,
          city_recursion: 1, //包含下一级行政区的教师
          level: this.level,
        };
        let res = await globalApi.post(data);

        if (res.data.data == null) {
          this.teacherList = [];
          this.teacher_sum = 0;
          return;
        }

        if (res.data.ret == 200 && res.data.data.result == 1) {
          this.teacherList = res.data.data.list;
          this.teacher_sum = res.data.data.recordcount;
        } else {
          this.$message.error("获取教师失败！");
        }
      } else {
        if (this.cur_city_id == "" || this.cur_city_id == 0) {
          this.$message.error("请先选择城市或区县！");
          return;
        }
        if (this.last_req_keyword != this.dialog_select_word) {
          this.dialog_page = 1;
        }
        this.last_req_keyword = this.dialog_select_word;
        let data = {
          s: "Common.EduBureau.GetResearch",
          group_id: this.zone_userid,
          city_id: this.cur_city_id,
          city_recursion: 1, //包含下一级行政区的教师
          page_size: this.dialog_page_size,
          page: this.dialog_page,
          user_id: this.user_id,
          keyword: this.dialog_select_word,
          schoolid: 1,
        };
        let res = await globalApi.post(data);
        if (res.data.data == null) {
          this.teacherList = [];
          this.teacher_sum = 0;
          return;
        }
        if (res.data.ret == 200 && res.data.data.result == 1) {
          this.teacherList = res.data.data.list;
          this.teacher_sum = res.data.data.recordcount;
        } else {
          this.$message.error("获取教研员失败！");
        }
      }
    },
    //根据机构名过滤当前列表
    async selTeacherFormOrg() {
      if (this.level != 3 && this.level != 4) {
        return;
      }
      this.dialog_select_word = "";
      this.teacherList = [];
      if (this.thisSelectUserType == 1) {
        let data = {
          s: "WebTeacherSpace.LessonPreparation.GetTeacherFormOrg",
          zone_userid: this.zone_userid,
          page_size: this.dialog_page_size,
          page: this.dialog_page,
          city_id: this.cur_city_id,
          city_recursion: 1, //包含下一级行政区的教师
          level: this.level,
          org_keyword: this.org_keyword,
        };
        let res = await globalApi.post(data);
        if (res.data.data == null) {
          this.teacherList = [];
          this.teacher_sum = 0;
          return;
        }
        if (res.data.ret == 200 && res.data.data.result == 1) {
          this.teacherList = res.data.data.list;
          this.teacher_sum = res.data.data.recordcount;
          if (this.teacher_sum == 0) {
            this.tsXx = "暂无数据";
          }
        } else {
          this.$message.error("获取教师失败！");
        }
      } else {
        let data = {
          s: "Common.EduBureau.getResearchFormOrg",
          group_id: this.zone_userid,
          city_id: this.cur_city_id,
          city_recursion: 1, //包含下一级行政区的教师
          page_size: this.dialog_page_size,
          page: this.dialog_page,
          user_id: this.user_id,
          schoolid: 1,
          org_keyword: this.org_keyword,
        };
        let res = await globalApi.post(data);

        if (res.data.data == null) {
          this.teacherList = [];
          this.teacher_sum = 0;
          return;
        }
        if (res.data.ret == 200 && res.data.data.result == 1) {
          this.teacherList = res.data.data.list;
          this.teacher_sum = res.data.data.recordcount;
        } else {
          this.$message.error("获取教研员失败！");
        }
      }
    },

    //添加成员
    addMember(item) {
      this.disabled2 = false;
      let count = 0;
      if (this.flag) {
        count = 15;
      } else {
        count = 14;
      }
      if (this.add_member_list.length >= count) {
        this.$message.error("最多只允许15位成员");
        return;
      }
      if (!this.isInArray(this.add_member_list, item.userid)) {
        this.tags.push(item);
        this.add_member_list.push(item.userid);
      }
    },

    //移除成员
    handleClose(tag) {
      this.disabled2 = false;
      // this.add_member_list.pop(tag.userid);
      let newData1 = this.add_member_list.filter(function (item) {
        return item != tag.userid;
      });
      this.add_member_list = newData1;
      let userid = tag.userid;
      let newData = this.tags.filter(function (item) {
        return item["userid"] != userid;
      });
      this.tags = newData;
    },

    //使用循环的方式判断一个元素是否存在于一个数组中
    isInArray(arr, value) {
      for (let i = 0; i < arr.length; i++) {
        if (value == arr[i]) {
          return true;
        }
      }
      return false;
    },

    // 获取登录数据
    async getLoginInfo() {
      const isLogin = this.websiteSessionInfo.logined;
      this.isLogin = isLogin;
      if (isLogin) {
        this.username = this.websiteSessionInfo.userName;
        this.userface = this.websiteSessionInfo.userFace;
        this.user_id = this.websiteSessionInfo.userid;
        this.login_userid = this.websiteSessionInfo.userid;

        this.uploadUrl = globalApi.GetWebHost("upload"); // 文件上传地址
        this.uploadData = {
          UserId: this.login_userid,
          SessionKey: this.websiteSessionInfo.sessionKey,
          OS: 4,
          CheckCode: globalApi.randomString(40),
        };
        this.options = {
          target: this.uploadUrl, // 上传地址
          testChunks: false,
          singleFile: false, // 启用单个文件上传。上传一个文件后，第二个文件将超过现有文件，第一个文件将被取消。
          chunkSize: "1048576" * 1, //分块大小 单位(M)
          query: {
            //传参
            UserId: this.login_userid,
            SessionKey: this.websiteSessionInfo.sessionKey,
            OS: 4,
            PluginType: 1,
          },
        };
        if (this.zone_userid == this.user_id) {
          this.role = "admin";
        } else {
          this.role = "visitor";
        }
      } else {
        globalApi.clearLoginInfo();
      }
    },

    // 解除组
    async delGroup(item) {
      const is_login = await globalApi.CheckAndGotoLogin();
      if (!is_login) {
        return;
      }
      this.delGroupVisible = true;
      this.cur_id = JSON.stringify([item.id]);
    },
    async delData() {
      const data = {
        s: "WebTeacherSpace.LessonPreparation.DeleteActivity",
        zone_userid: this.cur_id, //当前操作文章id
        userid: this.user_id,
      };
      const res = await globalApi.post(data);
      if (res.data.data.result == 1 && res.data.ret == 200) {
        (this.delGroupVisible = false), this.$message.success("删除成功！");
        this.getActivityInfoList();
        // this.$router.go(0);
      } else {
        this.$message.error("服务器忙~请稍后再试!");
      }
    },

    // 切换教师和教研员
    selectUserFun(val) {
      // 切换到教师
      if (val == 1) {
        this.buttonStyle1 = "primary";
        this.dialog_select_word = "";
        this.buttonStyle2 = "";
        this.thisSelectUserType = 1;
      }
      // 切换到教研员
      if (val == 2) {
        this.dialog_select_word = "";
        this.buttonStyle1 = "";
        this.buttonStyle2 = "primary";
        this.thisSelectUserType = 2;
      }
      this.dialog_page = 1;
      this.teacherList = [];
      this.teacher_sum = 0;
      this.provinceValue = "";
      this.districtValue = "";
      this.cityValue = "";
      this.org_keyword = "";
      this.getProvince();
    },

    // 获取集体备课列表
    async getActivityInfoList() {
      this.loading = true;
      const data = {
        s: "WebTeacherSpace.LessonPreparation.getActivityInfoList",
        zone_userid: this.zone_userid,
        page: this.cur_page,
        created_by_me: this.created_by_me,
        page: this.page,
        page_size: this.pageSize,
        // schoolid: this.schoolid,
        // srh_type: 1,
        is_back: true, //教师空间也需要取得被屏蔽数据
      };
      const response = await globalApi.post(data);
      const res = response.data.data;

      if (response.data.ret != 200) {
        return false;
      }
      if (res.result != 1) {
        return false;
      }

      this.tableData = res.list;
      this.loading = false;
      this.isData = this.tableData.length ? false : true;
      this.totle = res.recordcount;
      this.totle == 0 ? (this.isShow = true) : (this.isShow = false);
    },

    //创建集体备课
    async createActivity() {
      this.isSubmit = true;
      setTimeout(() => {
        this.isSubmit = false; //点击一次时隔两秒后才能再次点击
      }, 2000);
      const is_login = await globalApi.CheckAndGotoLogin();
      if (!is_login) {
        return;
      }
      if (this.actTitle == "") {
        this.$message.error("请输入标题");
        return;
      }
      let cur_time = new Date().valueOf();
      let endTime = this.endTime.valueOf();

      if (this.endTime == "") {
        this.$message.error("请选择结束时间！");
        return;
      }

      if (endTime < cur_time) {
        this.$message.error("开始时间不能晚于结束时间！");
        return;
      }

      if (this.add_member_list.length == 0) {
        this.$message.error("请选择成员！");
        return;
      }

      let res_list = JSON.stringify(this.file_resource_list);
      let member_list = JSON.stringify(this.add_member_list);
      const data = {
        s: "WebTeacherSpace.LessonPreparation.CreateActivity",
        operatorid: this.user_id,
        title: this.actTitle,
        end_time: endTime,
        describle: this.actIntro,
        res_list: res_list,
        member_list: member_list,
        permission: this.actAuth,
        form: 1,
      };
      const res = await globalApi.post(data);
      if (res.data.ret == 200 && res.data.data.result == 1) {
        this.addGroupVisible = false;
        this.$message.success("创建成功！");
        this.$router.go(0);
      } else {
        this.$message.error(res.data.msg);
        this.addGroupVisible = false;
      }
    },
    //获取上传文件的地址，以及是否成功
    handleSuccess: function (rootFile, file, response, chunk) {
      var res = JSON.parse(response);
      let tmpFile = {};
      tmpFile.resid = res.Data.Original;
      tmpFile.name = file.name;
      tmpFile.userid = this.user_id;
      tmpFile.time = parseInt(new Date().valueOf() / 1000);
      tmpFile.type = 1;
      if (res.Result) {
        this.file_resource_list.push(tmpFile);
      } else {
        if (response.ErrCode != 4) {
          this.$message.error(response.Errstr);
        }
      }
      this.isSubmit = false;
    },
    beforeRemove(file, fileList) {
      this.isSubmit = false;
      if (file.response == undefined) {
        return;
      }
      let id = file.response.Data.Original;
      let newData = this.file_resource_list.filter(function (item) {
        return item.resid != id;
      });
      this.file_resource_list = newData;
    },

    // @分片相关--------

    // 检查文件格式
    // fileName 文件名称
    // extensions 允许上传的格式
    checkExtensions(fileName, extensions) {
      var format = fileName.split(".").pop().toLowerCase(); // 用户上传的文件格式

      // 把允许上传文件格式的数组转为字符串
      var s = extensions.join(",");
      var exp = new RegExp(format);
      if (!exp.test(extensions)) {
        this.$message.warning("请上传 " + s + " 的格式!");
        return false;
      }
      return true;
    },

    // 检查文件大小
    checkSize(fileSize) {
      var FileLimit = this.FileLimit1;
      var isSize = fileSize / 1024 / 1024 < 1000; // 单位(M)
      if (!isSize) {
        this.$message.warning(
          " 文件大小不能大于" + FileLimit.FileMaxSize + FileLimit.FileUnit + "!"
        );
        return false;
      }
      return true;
    },

    // 添加一个文件时触发
    async filesAdded(file) {
      let that = this;
      //检验视频编码格式
      MediaInfo({ format: "object" }, (mediainfo) => {
        globalApi.onChangeFile(mediainfo, file, that);
      });
      const is_login = await globalApi.CheckAndGotoLogin();
      if (!is_login) {
        return;
      }
      if (this.$refs.uploader.uploader.fileList.length > 5) {
        file.ignored = true; // 过滤文件
        file.cancel(); // 停止上传
      }
      var FileLimit = this.FileLimit1;
      const isFormat = this.checkExtensions(file.name, FileLimit.FileFormat); // 文件格式判断
      if (!isFormat) {
        file.ignored = true; // 过滤文件
        file.cancel(); // 停止上传
        return false;
      }
      // 文件大小判断
      const isSize = this.checkSize(file.size);
      if (!isSize) {
        file.ignored = true; // 过滤文件
        file.cancel(); // 停止上传
        return false;
      } else {
        this.panelShow = true; // 展示上传panel
        // this.show_filename = false; // 不显示文件名
        this.computeMD5(file); // md5验证
      }
    },

    // 所选择的文件们添加到上传队列后触发
    filesSubmitted(files, fileList) {},

    // 文件上传中触发
    fileProgress(rootFile, file, chunk) {
      // 判断上传是否在上传
      if (file.isUploading()) {
        this.isSubmit = true;
        this.disabled2 = true;
        // this.show_filename = false; // 不显示文件名
      }
    },

    // 文件移除触发
    fileRemoved(file) {},

    // 上传成功后触发
    onFileSuccess: function (rootFile, file, response, chunk) {},

    // 上传错误触发
    onFileError(rootFile, file, response, chunk) {
      this.$message({
        message: "上传失败,请重新上传!",
        type: "error",
      });
    },

    // 校验MD5
    computeMD5(file) {
      let fileReader = new FileReader();
      let time = new Date().getTime();
      let blobSlice =
        File.prototype.slice ||
        File.prototype.mozSlice ||
        File.prototype.webkitSlice;
      let currentChunk = 0;
      const chunkSize = 10 * 1024 * 1000;
      let chunks = Math.ceil(file.size / chunkSize);
      let spark = new SparkMD5.ArrayBuffer();
      file.pause();

      loadNext();

      fileReader.onload = (e) => {
        spark.append(e.target.result);
        if (currentChunk < chunks) {
          currentChunk++;
          loadNext();
          this.$nextTick(() => {});
        } else {
          let md5 = spark.end();
          this.computeMD5Success(md5, file);
        }
      };
      fileReader.onerror = function () {
        this.error(`文件${file.name}读取出错，请检查该文件`);
        file.cancel();
      };

      function loadNext() {
        let start = currentChunk * chunkSize;
        let end =
          start + chunkSize >= file.size ? file.size : start + chunkSize;
        fileReader.readAsArrayBuffer(blobSlice.call(file.file, start, end));
      }
    },

    // 验证成功
    computeMD5Success(md5, file) {
      file.uniqueIdentifier = globalApi.randomString(32); //把md5值作为文件的识别码
      file.resume(); //开始上传
    },
  },
};
</script>
<style>
</style>
<style lang="scss" scoped>
.clearfix {
  clear: both;
  overflow: hidden;
  zoom: 1;
}
.main {
  width: 1200px;
  margin: 0px auto;
  min-height: 800px;
  background: #f6f9fa;
  padding-top: 20px;
  padding-bottom: 120px;
}
.top-operation {
  width: 100%;
  height: 48px;
  line-height: 48px;
  box-shadow: 0px 1px 0px 0px rgba(233, 233, 233, 1);
  .active {
    color: #0088ff;
  }
  span {
    float: right;
    margin-left: 20px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgba(102, 102, 102, 1);
  }
}
.group-list {
  width: 1200px;
  height: 104px;
  padding: 20px 0 10px 0;
  box-shadow: 0px 1px 0px 0px rgba(233, 233, 233, 1);

  .group-info {
    float: left;
    width: 1200px;
    .p1 {
      height: 35px;
      font-size: 18px;
      font-family: Microsoft YaHei;

      .title {
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
      }
      .status-going {
        font-weight: bold;
        color: red;
        margin-left: 30px;
      }
      .status-end {
        font-weight: bold;
        color: #999999;
        margin-left: 30px;
      }
    }
    .p2 {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
      height: 30px;
      .span-1 {
        margin-right: 35px;
      }
      .el-button {
        float: right;
        margin: 10px;
        position: relative;
        top: -20px;
      }
    }
  }
}
.el-pagination {
  text-align: center;
  padding: 20px 0 0px 0;
}

.p-1 {
  margin: 15px 0 15px 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  .title {
    font-size: 16px;
  }
  .el-input {
    width: 200px;
  }
  .el-button {
    width: 100px;
    margin-right: 20px;
  }

  .p1-span {
    font-size: 12px;
    color: #99a8b4;
    padding-left: 20px;
  }
  .el-select {
    margin-right: 20px;
  }
  .el-textarea {
    width: 420px;
  }
  .el-tag {
    margin: 5px 5px;
  }
}
.del-span {
  font-size: 12px;
  color: #99a8b4;
}
.el-upload__tip {
  color: #999;
  font-size: 12px;
}
.user-type {
  margin: 10px 0;
  text-align: center;
  .el-button {
    width: 150px;
    margin: 0 10px 0 0;
  }
}
.select-user {
  margin: 10px 0;
  .el-input {
    width: 85%;
  }
  .el-button {
    margin-left: 20px;
  }
}
.select-other {
  margin: 10px 0;
  background: #f6f9fa;
  padding: 10px;
  .el-select {
    width: 100px;
    margin-right: 5px;
  }
  .el-input {
    float: right;
    width: 150px;
  }
}
.usersInfo {
  table-layout: fixed;
  width: 100%;
  div {
    width: 530px;
  }
  .table-div {
    min-height: 440px;
  }
  tr {
    width: 100%;
  }

  .user-list {
    height: 35px;
    .user-face {
      margin-left: 20px;
      line-height: 35px;
      width: 30px;
      height: 30px;
      border-radius: 50%;
    }
    span,
    .el-button {
      font-family: Microsoft YaHei;
      font-weight: 400;
      font-size: 14px;
      position: relative;
      top: -8px;
      margin-left: 15px;
      line-height: 20px;
    }
    .username,
    .school_name {
      position: relative;
      top: -5px;
    }
  }
}
.schoolName {
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 8rem;
}
.none {
  height: 480px;
  line-height: 620px;
  text-align: center;
  background: url(../../assets/img/home_img_2.png) no-repeat center 100px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
}
.el-button + .el-button {
  margin: 0 0 0 -5px;
}
.el-dialog__footer {
  button {
    margin: 0 20px 10px 0;
  }
}
</style>
<style lang="scss">
.el-dialog__body {
  padding: 0px 20px 20px 20px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
}
.el-dialog__header {
  text-align: center;
}
.el-dialog {
  margin-top: 5vh !important;
}
.none-none {
  height: 280px;
  text-align: center;
  line-height: 280px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
}
</style>

<style>
.uploader-example {
  width: 550px;
  margin-left: 0px;
  margin-bottom: 10px;
  /* padding: 15px;
  margin-top: 20px; */
  font-size: 12px;
  /* box-shadow: 0 0 10px rgba(0, 0, 0, 0.4); */
}

.uploader-example .uploader-btn {
  margin-right: 4px;
}

.uploader-example .uploader-list {
  max-height: 440px;
  overflow: auto;
  overflow-x: hidden;
  overflow-y: auto;
}
.uploader-file-actions .uploader-file-pause {
  display: none !important;
}
.uploader-file-actions .uploader-file-resume {
  display: none !important;
}
.uploader-file-actions .uploader-file-retry {
  display: none !important;
}
.uploader-file-info .uploader-file-name .uploader-file-icon {
  /* display: none !important; */
}
.uploader-file-status span i {
  display: none !important;
}
.el-button--text {
  color: #409eff;
  background: 0 0;
  padding-left: 0;
  padding-right: 0;
  display: none;
}
</style>
<style lang="scss">
.uploader-btn:hover {
  background-color: #409eff !important;
}
.uploader-example {
  .uploader-drop {
    padding: 0px;
    border: 0px dashed #ccc;
    background-color: #ffffff;
  }
  .uploader-btn {
    color: #fff;
    background-color: #409eff;
    border-color: #409eff;
    white-space: nowrap;
    cursor: pointer;
    border: 1px solid #dcdfe6;
    text-align: center;
    box-sizing: border-box;
    padding: 7px 14px;
    font-size: 14px;
    border-radius: 4px;
  }
  .uploader-list {
    .uploader-file {
      border-bottom: 0px solid #cdcdcd;
    }
    .uploader-file-name {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 19px;
      color: rgba(33, 33, 33, 1);
      padding: 10px 0;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 15rem;
    }
    .uploader-file-size {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 19px;
      color: rgba(33, 33, 33, 1);
      padding: 10px 0;
    }
    .uploader-file-actions {
      width: 10%;
      position: relative;
      top: -5px;
    }
    .uploader-file-status {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 19px;
      color: rgba(33, 33, 33, 1);
      padding: 10px 0;
      color: #17c46d;
    }
    .uploader-file-icon {
      margin-top: -3px;
      margin-right: 8px;
    }
    .uploader-file-progress {
      background: #ffffff;
    }
  }
}
</style> */